<img [src]="storyData.instaPromoImageModel.src" (error)="onGameIconError(storyData)" />
